<template>
  <div class="mb-4">
    <h4 class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2">
      {{ $t('app.views.orders.modals.details.order_items') }}
    </h4>

    <!-- If order has persons, show grouped by person -->
    <div
      v-if="order.persons && order.persons.length > 0"
      class="space-y-4"
    >
      <div
        v-for="person in order.persons"
        :key="person.id"
        class="border-l-2 border-indigo-500 pl-3"
      >
        <h5 class="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-2 flex items-center gap-1">
          <svg
            class="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            />
          </svg>
          {{ person.name || $t('app.views.orders.modals.new_order.persons.person_label', {
            position: person.position
          }) }}
        </h5>

        <ItemsTable
          :items="person.items"
          :order="order"
        />
      </div>
    </div>

    <!-- Legacy view: show all items without grouping -->
    <ItemsTable
      v-else
      :items="order.items || []"
      :order="order"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import ItemsTable from './ItemsTable.vue'

interface Props {
  order: {
    persons?: Array<{
      id: number
      name?: string
      position?: number
      items: any[]
    }>
    items?: any[]
    order_type?: string
  }
}

const props = defineProps<Props>()
const { t } = useI18n()
</script>
